"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stringToHex = function (str, options) {
    var prefix = "0x";
    if (options && options.noPrefix) {
        prefix = "";
    }
    var padStart = 0;
    if (options && options.padStart) {
        padStart = options.padStart;
    }
    return prefix + new Buffer(str, "utf-8").toString("hex").padStart(padStart, "0");
};
exports.default = stringToHex;
